import {
  CHECKBOX_CHANGED_ACTION,
  DROPDOWN_CHANGED_ACTION,
  QqActionType,
  RESET_ACTION,
  SLIDER_CHANGED_ACTION,
} from "../qq-action.type";
import { QqMessageProcessorBase } from "./qq-message-processor.base";
import { CheckboxProcessor } from "./checkbox.processor";
import { SliderProcessor } from "./slider.processor";
import { DropdownProcessor } from "./dropdown.processor";
import { QqStateType } from "../qq-state.type";
import { SystemProcessor } from "./system.processor";

export class MessageProcessorFactory {
  private readonly factory: { [key: string]: () => QqMessageProcessorBase };

  constructor() {
    this.factory = {
      [CHECKBOX_CHANGED_ACTION]: () => new CheckboxProcessor(),
      [SLIDER_CHANGED_ACTION]: () => new SliderProcessor(),
      [DROPDOWN_CHANGED_ACTION]: () => new DropdownProcessor(),
      [RESET_ACTION]: () => new SystemProcessor(),
    };
  }

  process(action: QqActionType, state: QqStateType): QqStateType {
    if (!this.factory[action.type]) return state;

    return this.factory[action.type]().process(action, state);
  }
}
